import {
    Dropdown,
    makeStyles,
    Option,
    shorthands,
    useId,
} from "@fluentui/react-components";
import type {
    DropdownProps,
    OptionProps,
} from "@fluentui/react-components";
import {
    FaUser,
    FaUsers,
    FaRegBuilding,
    FaCheck,
} from "react-icons/fa";

const options = [
    { key: 'onlyme', text: 'Only me', icon: <FaUser /> },
    { key: 'team', text: 'Team', icon: <FaUsers /> },
    { key: 'department', text: 'Department', icon: <FaUsers /> },
    { key: 'organisation', text: 'Organisation', icon: <FaRegBuilding /> },
];

const useCustomOptionStyles = makeStyles({
    option: {
        display: "flex",
        alignItems: "center",
        ...shorthands.gap("5px"),
    },
    icon: {
        ...shorthands.flex(0, 0, "auto"),
    },
    text: {
        ...shorthands.flex(1, 1, "auto"),
    },
});

type CustomOptionProps = Partial<OptionProps> & {
    icon: JSX.Element;
    text: string;
};

const CustomOption = (props: CustomOptionProps) => {
    const { icon, text, ...optionProps } = props;
    const styles = useCustomOptionStyles();
    return (
        <Option
            text={text}
            className={styles.option}
            checkIcon={<FaCheck />}
            {...optionProps}
        >
            {icon && <span className={styles.icon}>{icon}</span>}
            <span className={styles.text}>{text}</span>
        </Option>
    );
};

const useStyles = makeStyles({
    root: {
        // Stack the label above the field with a gap
        display: "grid",
        gridTemplateRows: "repeat(1fr)",
        justifyItems: "start",
        ...shorthands.gap("2px"),
        maxWidth: "400px",
    },
    listbox: {
        maxHeight: "200px",
    },
});

export const WorkViewDropdown = (props: Partial<DropdownProps>) => {
    const dropdownId = useId("dropdown");
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <Dropdown
                aria-labelledby={dropdownId}
                listbox={{ className: styles.listbox }}
                {...props}
            >
                {options.map((option) => (
                    <CustomOption key={option.key} icon={option.icon} text={option.text} />
                ))}
            </Dropdown>
        </div>
    );
};
